module.exports = __webpack_public_path__ + "static/media/transferConvos.42ee0587.svg";